import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { LoginHelper } from '../../helpers/index';
import { DictionaryService } from '../../_services/dictionary.service';
import { SelectProjectControlItemComponent } from '../selectProjectControlItem/select-project-control-item.component';
import {RiskService} from "../../_services/risk.service";

@Component({
    standalone: false,
  selector: 'app-edit-risk',
  templateUrl: './edit-risk.component.html',
  styleUrls: ['./edit-risk.component.css'],
  providers: [DialogService],
})
export class EditRiskComponent {
  risk: any = {};
  options: string[];
  typeOptions: string[];
  visibility: any = {};
  finalDispositionOptions = ['Mitigate', 'Monitor', 'Accept'];


  businessUnitOptions: { label: string; value: string }[] = [];
  scoreOptions: { label: string; value: string }[] = [];

  controlsDialogRef: DynamicDialogRef | undefined;

  constructor(
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public riskService: RiskService,
    public dialogService: DialogService,
    public dictionaryService: DictionaryService,
  ) {
    this.options = ['Low', 'Medium', 'High'];
    this.typeOptions = ['Inherent', 'Residual', 'Other'];
    this.risk = {
      ...this.config.data.risk,
      relatedControlsList: this.config.data.risk.relatedControlsList
        ? [...this.config.data.risk.relatedControlsList]
        : [],
      typeList: (this.config.data.risk.type || '').split(',').filter(r => r && this.typeOptions.indexOf(r) >= 0)
    };

    if (this.risk.dateRaised) {
      this.risk.dateRaised = moment(this.risk.dateRaised).format('l');
    }
  }

  onSave() {
    this.risk.type = this.risk.typeList.join(',');
    this.dialogRef.close(this.risk);
  }

  onClose() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.loadDictionaryOptions();
  }

  private loadDictionaryOptions() {
    this.dictionaryService.get(['BusinessUnits', 'Scoring']).subscribe((dicts) => {
      dicts = dicts || [];

      const buDict = dicts.find(d => d.dictionary === 'BusinessUnits');
      const scoringDict = dicts.find(d => d.dictionary === 'Scoring');

      const businessUnits = (buDict?.businessUnits || []).filter(b => !!b);
      const scoring = (scoringDict?.scoring || []).filter(s => !!s);

      if (businessUnits.length > 0) {
        this.businessUnitOptions = businessUnits.map(bu => ({
          label: bu,
          value: bu
        }));
      } else {
        this.businessUnitOptions = [
          { label: 'Finance', value: 'Finance' },
          { label: 'HR', value: 'HR' },
          { label: 'Customer Support', value: 'Customer Support' }
        ];
      }

      if (scoring.length > 0) {
        this.scoreOptions = scoring.map(score => ({
          label: score,
          value: score
        }));
      } else {
        this.scoreOptions = Array.from({ length: 10 }, (_, i) => ({
          label: (i + 1).toString(),
          value: (i + 1).toString()
        }));
      }
    }, err => {
      console.error('Failed loading master dictionaries', err);
      // fallback to defaults
      this.businessUnitOptions = [
        { label: 'Finance', value: 'Finance' },
        { label: 'HR', value: 'HR' },
        { label: 'Customer Support', value: 'Customer Support' }
      ];

      this.scoreOptions = Array.from({ length: 10 }, (_, i) => ({
        label: (i + 1).toString(),
        value: (i + 1).toString()
      }));
    });
  }



  addToken(html) {
    return html
      ? html.replace(
          /api\/attachments\/file\?/gi,
          'api/attachments/file?token=' +
            LoginHelper.getFileToken() +
            '&'
        )
      : html;
  }

  addControl() {
    this.controlsDialogRef = this.dialogService.open(
      SelectProjectControlItemComponent,
      {
        width: '70%',
        contentStyle: { overflow: 'auto' },
        baseZIndex: 10010,
        maximizable: true,
        data: {},
        header: 'Select related controls',
      }
    );

    this.controlsDialogRef.onClose.subscribe((data: any) => {
      if (data) {
        this.risk.relatedControlsList.push({
          id: data.projectControlItemId,
          projectId: data.projectId,
          projectName: data.projectName,
          complianceAreaControlId: data.controlItem.complianceAreaControlId,
        });
      }
    });
  }

  makePoam(id) {
    this.riskService.makePoam(id, this.risk).subscribe();
  }

  removeControl(id) {
    this.risk.relatedControlsList = this.risk.relatedControlsList.filter(
      (c) => c.id !== id
    );
  }

  ngOnDestroy() {
    if (this.controlsDialogRef) {
      this.controlsDialogRef.close();
    }
  }
}
